export default "__VITE_ASSET__ffa6963a__"